// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7":"dfd38a6760e6211b","151":"31574cc1be0b7bac","242":"4f64c8a4ab1728f2","321":"cb61276e0410afcb","444":"cf681f3d31bf89e0","457":"740ca4168c951d4c","779":"fa9b442fe6c46da2"}[chunkId] + ".js";
};